import React from 'react';
import { useSelector } from 'react-redux';
import { getMyCars } from '../../../ducks/selectors';
import BankInformation from '../../bank-information/BankInformation';
import VehicleDetails from '../../future-packages/vehicle-details';
import AutopayDetails from './autopay-details/AutopayDetails';
import {
  SetUpAutopayCardWrapper,
  SetUpAutopayTitle,
  HR,
} from './SetUpAutopayCard.styles';

const SetupAutopayCard = (props: { vehicleId: any }) => {
  const myCars = useSelector(getMyCars);

  const { vehicleId } = props;

  const loanDetailCar: any = myCars.find(
    (car: any) => car.vehicle.vehicleId === Number(vehicleId)
  );

  const isPaidInFull = loanDetailCar?.loanDetails?.loanState === 'PaidOffLoan';

  return (
    <>
      <SetUpAutopayTitle>
        Set Up Autopay for Your Bridgecrest Account
      </SetUpAutopayTitle>

      <SetUpAutopayCardWrapper>
        <VehicleDetails
          myCar={loanDetailCar.vehicle}
          status={loanDetailCar.status}
        />
        <HR />
        <AutopayDetails loanDetailCar={loanDetailCar} />
      </SetUpAutopayCardWrapper>
      <BankInformation
        vehicleId={vehicleId}
        bankAccounts={loanDetailCar.bankInfo}
        updateBankTrackEvent="auto_pay_edit_bank_details_button_tap"
        isPaidInFull={isPaidInFull}
        isHalfView={false}
      />
    </>
  );
};

export default SetupAutopayCard;
